import { render } from "./Constant_Dizziness.vue?vue&type=template&id=9488ca72"
import script from "./Constant_Dizziness.vue?vue&type=script&lang=js"
export * from "./Constant_Dizziness.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__